import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
//import { SearchBySkillOrConsultantPageActions } from '@skills-app/consultant-skill/actions';
import { IIndustryItem } from "@skills-app/models/industry";
import { AppState } from "@skills-app/root.reducer";
import { IndustryService } from "@skills-app/services/industry.service";
import { catchError, map, switchMap } from "rxjs/operators";
import { ConsultantSearchIndustryApiActions } from "@skills-app/industry/actions";
import { HttpErrorResponse } from "@angular/common/http";
import { EMPTY } from "rxjs";
import { IndustrySearchBarActions } from "@skills-app/consultant-skill/actions";

@Injectable()
export class IndustryEffects {
  constructor(
    private industryService: IndustryService,
    private actions$: Actions,
    private store$: Store<AppState>,
  ) {}

  loadSkills$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        ConsultantSearchIndustryApiActions.requestIndustryItems,
        IndustrySearchBarActions.loadComponent,
      ),
      switchMap(() =>
        this.industryService.getIndustryOptions().pipe(
          map((items: IIndustryItem[]) =>
            ConsultantSearchIndustryApiActions.populateIndustryItems({ items }),
          ),
          catchError((error: HttpErrorResponse) => EMPTY),
        ),
      ),
    ),
  );
}
